// import * as utils from '@/utils/utils';

import { exportFiles } from '@/utils/utils'
import { Message } from 'antd'
import services from '../services/member.js'

const {
  getMemberserviceList,
  getFilterTypeList,
  getBranchInfo,
  getBranchApprovals,
  changeBadRecord,
  replyLicense,
  getApprovalOperate,
  getMemberList,
  updateMemberInfo,
  getListMakeCert,
  getProvince,
  getCity,
  getArea,
  exportApprovalList,
  approvalMemUsers,
  replyMemUsers,
  exportMakeCert,
  payConfirmMemUsers,
  getCurrentYear,
  getPaymenList,
  oldMemberPaymentConfirm,
  changeCert,
} = services

const namespace = 'member'

export default {
  namespace,
  state: {
    memberServiceDataSource: {}, // 列表数据
    memberTypeList: [], // 会员类型
    enterpriseTypeList: [], // 企业类型
    provinceNameValues: [], // 所在地列表
    provinceList: [], // 省列表
    cityList: [], // 市列表
    areaList: [], // 区列表
    detailInfo: {},
    userInfo: {
      code: '',
      enterpriseName: '',
      enterpriseAddress: '',
      legalPerson: '',
      legalPersonPosition: '',
      enterprisePrincipal: '',
      enterprisePrincipalPosition: '',
      enterpriseTypeName: '',
      enterpriseWeb: '',
      establishedTime: '',
      contactName: '',
      contactPhone: '',
      contactPosition: '',
      enterpriseFax: '',
      contactQq: '',
      contactLandline: '',
      contactDepartment: '',
      applicationTime: '',
      registrationTime: '',
      renewalTime: '',
      associationName: '',
      memberTypeName: '',
      memberType: 1,
      type: 1,
      generalList: [],
      generalValueList: [],
      majorList: [],
      majorValueList: [],
    },
    approvalList: [
      {
        title: '11', //
        description: '1111111', // 描述信息
        status: 'finish', // 状态 finish:节点完成 process:当前进行中 wait:未进行 error:出错
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'process', // 状态
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'wait ', // 状态
      },
      {
        title: '222', //
        description: '222222', // 描述信息
        status: 'error', // 状态
      },
    ],
    componenyFiles: [],
    qualificationFiles: [],
    payconfirmDetailData: [],
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    *getMemberserviceList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberserviceList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberServiceDataSource: res.data,
          },
        })
        !!callback && callback(res)
      } else {
        Message.error(res.msg)
      }
    },
    *getFilterTypeList({ payload }, { call, put }) {
      const res = yield call(getFilterTypeList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberTypeList: res.data.assoOrgNameValues,
            enterpriseTypeList: res.data.businessScopes,
            provinceNameValues: res.data.enterpriseTypes,
          },
        })
      }
    },

    // 获取省
    *getProvince({ payload }, { call, put }) {
      const res = yield call(getProvince, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            provinceList: res.data.regionlist || [],
          },
        })
      }
    },

    // 获取市
    *getCity({ payload }, { call, put }) {
      if (payload.id) {
        const res = yield call(getCity, { ...payload })
        if (res && res.success) {
          yield put({
            type: 'updateState',
            payload: {
              cityList: res.data.regionlist || [],
            },
          })
        }
      } else {
        yield put({
          type: 'updateState',
          payload: {
            cityList: [],
          },
        })
      }
    },
    // 获取区
    *getArea({ payload }, { call, put }) {
      if (payload.id) {
        const res = yield call(getArea, { ...payload })
        if (res && res.success) {
          yield put({
            type: 'updateState',
            payload: {
              areaList: res.data.regionlist || [],
            },
          })
        }
      } else {
        yield put({
          type: 'updateState',
          payload: {
            areaList: [],
          },
        })
      }
    },

    // 获取分会用户信息
    *getBranchInfo({ payload, callback }, { call, put }) {
      const res = yield call(getBranchInfo, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            userInfo: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    // 查看历史会员证
    *getMemberList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            membershipList: {
              ...res.data,
            },
          },
        })
      } else {
        Message.error(res.globalError)
      }
    },

    // 分会审批进度查询
    *getBranchApprovals({ payload }, { call, put }) {
      const res = yield call(getBranchApprovals, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            approvalList: res.data,
          },
        })
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },
    // 审批操作
    *getApprovalOperate({ payload, callback }, { call, put }) {
      const res = yield call(getApprovalOperate, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 新会员发证
    *replyLicense({ payload, callback }, { call, put }) {
      const res = yield call(replyLicense, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 修改会员信息
    *updateMemberInfo({ payload, callback, onError }, { call, put }) {
      const res = yield call(updateMemberInfo, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        callback()
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 旧会员发证
    *changeCert({ payload, callback }, { call, put }) {
      const res = yield call(changeCert, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 获取新会员发证列表
    *getListMakeCert({ payload, callback }, { call, put }) {
      const res = yield call(getListMakeCert, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberServiceDataSource: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    // 审批列表导出Excel
    *exportApprovalList({ payload, callback }, { call, put }) {
      const res = yield call(exportApprovalList, { ...payload })
      exportFiles(res, '待信息审核列表.xlsx')
      !!callback && callback(res)
    },

    // 批量导出制证
    *exportMakeCert({ payload, callback }, { call, put }) {
      const res = yield call(exportMakeCert, { ...payload })
      !!callback && callback(res)
      exportFiles(res, '新会员批量导出制证.xlsx')
    },

    // 批量审核
    *approvalMemUsers({ payload, callback }, { call, put }) {
      const res = yield call(approvalMemUsers, { ...payload })
      if (res && res.success) {
        Message.success('审核成功')
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 批量批复
    *replyMemUsers({ payload, callback }, { call, put }) {
      const res = yield call(replyMemUsers, { ...payload })
      if (res && res.success) {
        Message.success('批复成功')
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 批量缴费确认
    *payConfirmMemUsers({ payload, callback }, { call, put }) {
      const res = yield call(payConfirmMemUsers, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 老会员缴费确认
    *oldMemberPaymentConfirm({ payload, callback }, { call, put }) {
      const res = yield call(oldMemberPaymentConfirm, { ...payload })
      if (res && res.success) {
        Message.success('缴费确认成功')
        !!callback && callback(res)
      } else {
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    // 缴费详情查看
    *getPaymenList({ payload, callback }, { call, put }) {
      const res = yield call(getPaymenList, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          payconfirmDetailData: res.data,
        },
      })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },

    // 查询当前年度
    *getCurrentYear({ payload, callback }, { call, put }) {
      const res = yield call(getCurrentYear, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },
    // 查询当前年度
    *changeBadRecord({ payload, callback }, { call, put }) {
      const res = yield call(changeBadRecord, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },

    *resetCity({}, { put }) {
      yield put({
        type: 'updateState',
        payload: {
          cityList: [],
          areaList: [],
        },
      })
    },
  },
  // 订阅事件
  subscriptions: {},
}
